import './polyfills.esm'
import * as regeneratorRuntime from 'regenerator-runtime'

const corejs = Object.create(window)

export { regeneratorRuntime, corejs }
